import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const NotificationHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        style={{ padding: '0 20px' }}
        ghost={false}
        title={t('components.pages.notifications.list.pageHeader.title')}
      />
    </>
  )
}

NotificationHeader.displayName = 'NotificationHeader'
export default NotificationHeader
